import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';
import * as Papa from 'papaparse';


@Injectable({
  providedIn: 'root'
})
export class FileUploadService {
  private validExtensions: string[] = ['.xlsx', '.xls', '.csv'];

  constructor(private _utils: UtilsService) { }

  /**
   * Thit api get all automated file parser config using brand id;
   * @param params {brand_id:string}
   */
  getAllConfigurations(brandId: string) {
    const url = this._utils.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.AFPConfigUrl);
    return this._utils.getAPICall(url, this._utils.setHeaderWithParams({ "brand_id": brandId }));
  }

  saveConfiguration(configs: any) {
    const url = this._utils.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.AFPConfigUrl);
    return this._utils.postAPICall(url, configs, this._utils.setHeaders());
  }

  updateConfiguration(configs: { "config_name": any, "afp_configs": any }) {
    const url = this._utils.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.AFPConfigUrl);
    return this._utils.putAPICall(url, configs, this._utils.setHeaders());
  }

  uploadFile(files: any, configs: any) {

    const formData = new FormData();
    formData.append("file", files[0]);
    formData.append("fields", configs);
    formData.append("file_name", files[0].name);
    const url = this._utils.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.infraFileUpload);
    return this._utils.putAPICall(url, formData, this._utils.setHeaders());

  }

  validateUserAnduploadFile(files: any, configs: any) {

    const formData = new FormData();
    formData.append("file", files[0]);
    formData.append("fields", configs);
    formData.append("file_name", files[0].name);
    const url = this._utils.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.validateUserAndCreateRequest);
    return this._utils.putAPICall(url, formData, this._utils.setHeaders());

  }

  getFileJobsStatus(params: {
    "brand_id": string,
    "job_type": string,
    "file_type": string,
    "page_number": number,
    "limit": number
  }) {

    const url = this._utils.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.infraJobStatus);
    return this._utils.getAPICall(url, this._utils.setHeaderWithParams(params));
  }

  getPublicUrl(params: {
    'brand_id': string,
    'file_url': string,
    'type': any
  }) {
    const url = this._utils.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.infraFileUrl);
    return this._utils.getAPICall(url, this._utils.setHeaderWithParams(params));
  }

  uploadHierarchyFile(configs, files) {
    const formData = new FormData();
    formData.append("file", files[0]);
    formData.append("fields", configs);
    formData.append("file_name", files[0].name);
    const url = this._utils.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.hierarhchyFileUpload);
    return this._utils.putAPICall(url, formData, this._utils.setHeaders());
  }


  checkFileExtension(fileName: string): string | null {
    try {
      if (!fileName) return null;
      const fileExtension = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
      return this.validExtensions.includes(fileExtension) ? fileExtension : null;
    } catch (error) {
      console.error('Error while checking file extension:', error);
      return null;
    }
  }


  parseCSV(file: File): Promise<{ data?: any[], error?: string }> {
    return new Promise((resolve) => {
      Papa.parse(file, {
        complete: (results) => {
          if (results.errors.length > 0 && results.errors[0]?.code !== "UndetectableDelimiter") {
            resolve({ error: "Some error occurred while reading the file, please select a different file." });
          } else if (results.data.length > 0) {
            resolve({ data: results.data });
          } else {
            resolve({ error: "File is empty or could not be parsed." });
          }
        }
      });
    });
  }


}
